function initializeContentRating() {

  const cookieName = 'SCCUContentHelpfulRatingIDs'
  const yesButtons = $('[data-document-yes]')
  const noButtons = $('[data-document-no]')
  let ratingControl = '#helpful-control-'
  let thankyouMessage = '#rating-received-'
  let cookieValue = ''
  let cookieArray = []

  //Check cookie
  function getCookieValueByRegEx(a, b) {
    b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)');
    return b ? b.pop() : '';
  }

  function addCssClass(el, property) {
    $(el).addClass(property);
  }

  function removeCssClass(el, property) {
    $(el).removeClass(property);
  }

  function registerEvents() {
    if (yesButtons.length > 0) {
      $(yesButtons).each(function (index) {
        
        $(this).on('click', function () {
          ratingControl = '#helpful-control-'
          thankyouMessage = '#rating-received-'
          let documentId = $(this).data('document-yes')
          ratingControl += documentId
          thankyouMessage += documentId
          sendRating(documentId, true)
        })
      })
    }

    if (noButtons.length > 0) {
      $(noButtons).each(function (index) {
        
        $(this).on('click', function () {
          ratingControl = '#helpful-control-'
          thankyouMessage = '#rating-received-'
          let documentId = $(this).data('document-no')
          ratingControl += documentId
          thankyouMessage += documentId
          sendRating(documentId, false)
        })
      })
    }

  }

  function sendRating(a, b) {
    ratingControl = '#helpful-control-'
    thankyouMessage = '#rating-received-'
    ratingControl += a
    thankyouMessage += a

    $.ajax({
      url: '/webapi/contenthelpfulratingapi/helpful',
      method: 'POST',
      data: JSON.stringify({
        DocumentId: a,
        Rating: b
      }),
      contentType: 'application/json; charset=utf-8',
      success: function (response) {
        console.log('sucess')
      },
      error: function (errorMsg) {
        console.log(errorMsg);
      }

    })
    addCssClass($(ratingControl), 'd-none')
    removeCssClass($(thankyouMessage), 'd-none')

  }

  function checkCookie() {
    cookieValue = decodeURIComponent(getCookieValueByRegEx(cookieName))
    if (cookieValue.length > 0) {
      cookieArray = cookieValue.split('|')
      
    }
  }

  function checkDocumentRating(docId) {
    if (cookieArray.includes(docId.toString())) {
      ratingControl += docId
      thankyouMessage += docId
      addCssClass($(ratingControl), 'd-none')
      removeCssClass($(thankyouMessage), 'd-none')

    }
  }

  function validateUserRating() {
    
    if (yesButtons.length > 0) {
      $(yesButtons).each(function (el) {
        ratingControl = '#helpful-control-'
        thankyouMessage = '#rating-received-'
        let documentId = $(this).data('document-yes')
        checkDocumentRating(documentId)
      })
    }

    if (noButtons.length > 0) {
      $(noButtons).each(function (el) {
        ratingControl = '#helpful-control-'
        thankyouMessage = '#rating-received-'
        let documentId = $(this).data('document-no')
        checkDocumentRating(documentId)
      })
    }
  }
  
  // Load
  registerEvents();
  checkCookie();
  if (cookieArray.length > 0) {
    validateUserRating();
  }
  
}


document.addEventListener('DOMContentLoaded', (event) => {
  initializeContentRating()
})

